import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { WorkOrderDetailsViewModel } from 'projects/Administration/src/app/business-entities/work-order-details-view-model';
import { AppointmentService } from 'projects/Administration/src/app/business-services/appointment.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { VehicleBusinessService } from 'projects/Administration/src/app/business-services/vehicle-service';
import { MultiStackPopupService } from 'projects/Administration/src/app/services/multi-stack-popup.service';

@Component({
  selector: 'app-active-work-orders',
  templateUrl: './active-work-orders.component.html',
})
export class ActiveWorkOrdersComponent implements OnInit {
  activeWorkOrdersList: WorkOrderDetailsViewModel[] = [];
  totalCount: number = 0;
  throttle = 100;
  scrollDistance = 1;
  activeWorkOrdersRequestModel = {
    AppointmentGuid: '',
    DealerId: '',
    LicensePlate: '',
    LanguageCode: '',
    StartRecordNumber: 0,
    PageSize: 25
  };

  constructor(
    private appointmentService: AppointmentService,
    private spinner: NgxSpinnerService,
    private editAppointmentService: EditAppointmentService,
    private cookieservice: CookieService,
    private vehicleBusinessService: VehicleBusinessService,
    private activeModal: NgbActiveModal,
    private multiStackPopupService: MultiStackPopupService
  ) { }

  ngOnInit(): void {
    this.activeWorkOrdersRequestModel.StartRecordNumber = 0;
    this.activeWorkOrdersRequestModel.LanguageCode = this.cookieservice.get('userSelectedLanguage');
    if (this.editAppointmentService.isFromVehicleHistoricalTab) {
      this.activeWorkOrdersRequestModel.AppointmentGuid = '';
      this.activeWorkOrdersRequestModel.DealerId = '';
      this.activeWorkOrdersRequestModel.LicensePlate = this.vehicleBusinessService.licensePlate;
    } else {
      this.activeWorkOrdersRequestModel.AppointmentGuid = this.editAppointmentService.appointmentDetails.appointmentGuid;
      this.activeWorkOrdersRequestModel.DealerId = this.editAppointmentService.appointmentDetails.dealerId;
      this.activeWorkOrdersRequestModel.LicensePlate = this.editAppointmentService.appointmentDetails.licensePlate;
    }
    this.getActiveWorkOrders();
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.activeWorkOrdersList.length) {
      this.activeWorkOrdersRequestModel.StartRecordNumber = this.activeWorkOrdersList.length;
      this.getActiveWorkOrders();
    }
  }

  //Active work orders
  getActiveWorkOrders() {
    this.spinner.show();
    this.appointmentService
      .GetActiveWorkOrder(this.activeWorkOrdersRequestModel)
      .then((response) => {
        if (response) {
          this.activeWorkOrdersList.push(...this.ActiveWorkOrdersDataMapper(response));
          this.totalCount = this.activeWorkOrdersList[0].totalCount;
        }
      }).finally(()=>{
        this.spinner.hide();
      });
  }

  //Active work orders mapper
  private ActiveWorkOrdersDataMapper(woList: any): any[] {
    let supperArray = [];
    if (woList && woList.length > 0) {
      woList.forEach(element => {
        let single = Object();
        single.workOrderNumber = element.workOrderNumber;
        single.licensePlate = element.licensePlate;
        single.vehicleModel = element.vechicelModel;
        single.brandName = element.brandName;
        single.brandCode = element.brandCode;
        single.customerFullName = element.customerFullName;
        single.services = element.services;
        single.appointmentDate = element.appointmentDate;
        single.workOrderStatus = element.workOrderStatus;
        single.workOrderColor = element.workOrderColor;
        single.appointmentId = element.appointmentId;
        single.totalCount = element.totalCount;
        single.dealer = element.dealer;
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  async OpenEditView(woDetail: any) {
    this.multiStackPopupService.OpenAppointment(woDetail.appointmentId);
  }
  //Cancel button
  OnClose() {
    this.activeModal.close({ success: false });
  }
}
